import React from "react";
import "../styles/ChecklistCard.css";
import Clause from "./Clause";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function BCClauseCard({
  ClauseDataCommon,
  ClauseDataSituational,
  ClauseCardDescription,
}) {
  return (
    <div className="checklist-card checklist-card-modern">
      <div className="flex flex-wrap checklist-card-header">
        <div>{ClauseCardDescription[0].title}</div>
      </div>
      <div className="clause-card-content">
        <div
          className="clause-card-description"
          dangerouslySetInnerHTML={{
            __html: ClauseCardDescription[0].text,
          }}
        />
        <div className="clause-warning">
          <div className="clause-warning-icon">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <div>
            If your Client chooses not to include any recommended
            Conditions/Clauses in their offer, or chooses not to follow any other
            advice given, be sure to complete:{" "}
            <strong>
              Buyer's Acknowledgement of Advice, Rights and Benefits Form.
            </strong>
          </div>
        </div>
      {ClauseDataCommon.length === 0 ? (
        ""
      ) : (
        <h2 className="clause-section-title">{ClauseCardDescription[0].title}</h2>
      )}

      <ul className="clause-list">
        {ClauseDataCommon.map((item, index) => (
          <div key={index} className="clause-list-item">
            <Clause Clause={item} />
          </div>
        ))}
      </ul>
      {ClauseDataSituational.length === 0 ? (
        ""
      ) : (
        <h2 className="clause-section-title">Common Terms/Clauses</h2>
      )}

      <ul className="clause-list">
        <ul className="clause-list">
          {ClauseDataSituational.map((item, index) => (
            <div key={index} className="clause-list-item">
              <Clause Clause={item} />
            </div>
          ))}
        </ul>
      </ul>
      </div>
    </div>
  );
}
